/* esm.sh - tslib@2.8.1 */
export * from "/*tslib@2.8.1/esnext/tslib.mjs";
export { default } from "/*tslib@2.8.1/esnext/tslib.mjs";
